import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import cn from 'classnames'
import {
  fetchFormEventListWithData,
  saveEventForm,
} from 'reducers/logbookForm/reducer'
import { LOGBOOK_FORM } from 'constants/requestTypes'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import { TYPE_INPUT_FILE, TYPE_INPUT_TEXTAREA } from 'helpers/logbook'
import withPromise from 'helpers/withPromise'
import ContentLoader from './ContentLoader'
import Breadcrumbs from './Breadcrumbs'
import FormList from './FormList'
import LocusGroupList from './LocusGroupList'
import LocusList from './LocusList'
import EventList from './EventList'

class Content extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeForm: null,
      activeLocusGroup: null,
      activeLocus: null,
      activeEvent: null,
      activeAllEvents: true,
      breadcrumbs: this.initBreadcrumbs(),
      ...this.initShowListsState({
        showFormList: true,
      }),
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.activeSite !== nextProps.activeSite) {
      this.setState({
        activeForm: null,
        activeLocusGroup: null,
        activeLocus: null,
        activeEvent: null,
        activeAllEvents: true,
        breadcrumbs: this.initBreadcrumbs(),
        ...this.initShowListsState({
          showFormList: true,
        }),
      })

      return false
    }

    if (
      this.state.showSettingList &&
      this.props.activeDate !== nextProps.activeDate
    ) {
      this.setState({
        activeEvent: null,
        activeAllEvents: true,
      })
      this.fetchFormEventListWithData(nextProps, nextState)

      return false
    }

    return true
  }

  initShowListsState = params => {
    const isMobile = ifWindowWidthLessThan(1024)
    const state = {
      showFormList: false,
      showLocusGroupList: false,
      showLocusList: false,
      showSettingList: false,
    }

    if (typeof params === 'object') {
      if (isMobile) {
        const paramKeys = Object.keys(params)
        const lastTrueKey = paramKeys.reduce((lastTrueKey, key) => {
          if (params[key] && Object.prototype.hasOwnProperty.call(state, key)) {
            // eslint-disable-next-line no-param-reassign
            lastTrueKey = key
          }

          return lastTrueKey
        }, null)

        if (lastTrueKey) {
          state[lastTrueKey] = true
        }
      } else {
        for (const key in params) {
          if (
            Object.prototype.hasOwnProperty.call(params, key) &&
            Object.prototype.hasOwnProperty.call(state, key)
          ) {
            state[key] = params[key]
          }
        }
      }
    }

    return state
  }

  initBreadcrumbs = () => ({
    form: {
      title: null,
      data: null,
      onClick: this.onBcFormClick,
    },
    locusGroup: {
      title: null,
      data: null,
      onClick: this.onBcLocusGroupClick,
    },
    locus: {
      title: null,
      data: null,
      onClick: this.onBcLocusClick,
    },
  })

  getBreadcrumbs = (param, value, data) => {
    const oldBreadcrumbs = this.state.breadcrumbs
    const breadcrumbs = this.initBreadcrumbs()

    // eslint-disable-next-line guard-for-in
    for (const key in breadcrumbs) {
      if (
        Object.prototype.hasOwnProperty.call(breadcrumbs, key) &&
        key === param
      ) {
        breadcrumbs[param].title = value
        breadcrumbs[param].data = data
        break
      }

      breadcrumbs[key] = oldBreadcrumbs[key]
    }

    return breadcrumbs
  }

  onBcFormClick = () => {
    this.onFormListItemClick(this.state.breadcrumbs.form.data)
  }

  onBcLocusGroupClick = () => {
    this.onLocusGroupListItemClick(this.state.breadcrumbs.locusGroup.data)
  }

  onBcLocusClick = () => {
    this.onLocusListItemClick(this.state.breadcrumbs.locus.data)
  }

  onBcBackClick = () => {
    if (this.state.breadcrumbs.locus.data !== null) {
      return this.onBcLocusGroupClick()
    }

    if (this.state.breadcrumbs.locusGroup.data !== null) {
      return this.onBcFormClick()
    }

    this.setState({
      activeForm: null,
      activeLocusGroup: null,
      activeLocus: null,
      breadcrumbs: this.initBreadcrumbs(),
      ...this.initShowListsState({
        showFormList: true,
      }),
    })
  }

  onFormListItemClick = form => {
    const {
      intl: { formatMessage },
    } = this.props
    const showList = {
      showFormList: true,
      showLocusGroupList: form.needs_locus_group,
      showLocusList: !form.needs_locus_group && form.needs_locus,
      showSettingList:
        !form.needs_locus_group &&
        !form.needs_locus &&
        (form.events.length > 1 ||
          Object.prototype.hasOwnProperty.call(form.events[0], 'slaves')),
    }

    this.setState(
      {
        activeForm: form,
        activeLocusGroup: null,
        activeLocus: null,
        activeEvent: null,
        activeAllEvents: true,
        breadcrumbs: this.getBreadcrumbs(
          'form',
          formatMessage({ id: form.title }),
          form,
        ),
        ...this.initShowListsState(showList),
      },
      () => {
        if (!form.needs_locus_group && !form.needs_locus) {
          this.fetchFormEventListWithData(this.props, this.state)
        }
      },
    )
  }

  onLocusGroupListItemClick = locusGroup => {
    const { activeForm } = this.state
    const showList = {
      showFormList: true,
      showLocusGroupList: true,
      showLocusList: activeForm.needs_locus,
      showSettingList:
        !activeForm.needs_locus &&
        (activeForm.events.length > 1 ||
          Object.prototype.hasOwnProperty.call(activeForm.events[0], 'slaves')),
    }

    this.setState(
      {
        activeLocusGroup: locusGroup,
        activeLocus: null,
        activeEvent: null,
        activeAllEvents: true,
        breadcrumbs: this.getBreadcrumbs(
          'locusGroup',
          locusGroup.name,
          locusGroup,
        ),
        ...this.initShowListsState(showList),
      },
      () => {
        if (!activeForm.needs_locus) {
          this.fetchFormEventListWithData(this.props, this.state)
        }
      },
    )
  }

  onLocusListItemClick = locus => {
    const { activeForm } = this.state

    this.setState(
      {
        activeLocus: locus,
        activeAllEvents: true,
        breadcrumbs: this.getBreadcrumbs('locus', locus.containerName, locus),
        ...this.initShowListsState({
          showFormList: true,
          showLocusGroupList: activeForm.needs_locus_group,
          showLocusList: true,
          showSettingList: true,
        }),
      },
      () => {
        this.fetchFormEventListWithData(this.props, this.state)
      },
    )
  }

  showAllSlaveEvents = () => {
    this.setState({
      activeAllEvents: true,
    })
  }

  onEventValueChange = data => {
    const form = {}
    const { activeSite, activeDate, saveEventForm } = this.props
    const {
      evt_logbook_id,
      type,
      value,
      activeForm,
      activeLocusGroup,
      activeLocus,
      needs_event_date,
      setResultId,
      parameters,
      parentEvtLogbook,
      master,
      masterEvent,
      masterEventIsNew,
    } = data
    const multipleEvent =
      Object.prototype.hasOwnProperty.call(
        parameters,
        'multiple_values_per_day',
      ) && parameters.multiple_values_per_day
    const eventLogbookId = Boolean(evt_logbook_id)

    switch (type) {
      case TYPE_INPUT_TEXTAREA:
        form.comment = value
        break
      case TYPE_INPUT_FILE:
        form.file = value
        break
      default:
        form.result = value
    }

    if (master) {
      form.master = master
    }

    if (parentEvtLogbook) {
      form.parent_evt_logbook = parentEvtLogbook
    }

    if (!eventLogbookId || multipleEvent) {
      form.site = activeSite
      form.event = data.id
    }

    if (needs_event_date && (!eventLogbookId || multipleEvent)) {
      form.event_date = activeDate.format('YYYY-MM-DD')
    }

    if (activeForm.needs_locus_group) {
      form.locus_group = activeLocusGroup
        ? activeLocusGroup.id
        : data.locus_group_id
    }

    if (activeForm.needs_locus) {
      form.locus = activeLocus ? activeLocus.id : data.locus_id
    }

    if (masterEvent && !masterEventIsNew) {
      this.fetchFormEventListWithData(this.props, this.state)

      return
    }

    withPromise(saveEventForm, {
      form,
      event:
        eventLogbookId && !multipleEvent ? { event: evt_logbook_id } : null,
      params: {
        type: LOGBOOK_FORM,
      },
    }).then(response => {
      if (response && !response.errors) {
        setResultId(response)

        if (masterEvent) {
          this.fetchFormEventListWithData(this.props, this.state)
        }
      }
    })
  }

  fetchFormEventListWithData = (props, state) => {
    const { activeSite, activeDate, fetchFormEventListWithData } = props
    const { activeForm, activeLocusGroup, activeLocus } = state
    const payload = {
      params: {
        site: activeSite,
        date: activeDate.utc().format('YYYY-MM-DD'),
      },
    }

    if (activeForm !== null) {
      payload.form = activeForm.id

      if (activeLocusGroup !== null) {
        payload.params.locus_group = activeLocusGroup.id
      }

      if (activeLocus !== null) {
        payload.params.locus = activeLocus.id
      }

      fetchFormEventListWithData(payload)
    }
  }

  onEventClick = (e, eventInfoId) => {
    const { activeEvent, activeAllEvents } = this.state
    const { target } = e

    if (target.className && !target.className.includes('MuiInput-input')) {
      if (activeAllEvents) {
        this.setState({
          activeAllEvents: false,
        })

        return
      }

      if (activeEvent === eventInfoId) {
        this.setState({
          activeEvent: null,
        })
      } else {
        this.setState({
          activeEvent: eventInfoId,
        })
      }
    }
  }

  render() {
    const {
      activeForm,
      activeLocusGroup,
      activeLocus,
      showFormList,
      showLocusGroupList,
      showLocusList,
      showSettingList,
      breadcrumbs,
      activeEvent,
      activeAllEvents,
    } = this.state

    return (
      <>
        <ContentLoader />
        <Breadcrumbs breadcrumbs={breadcrumbs} backClick={this.onBcBackClick} />
        <div
          className={cn('lbf-content', {
            desktop: !ifWindowWidthLessThan(1024),
          })}>
          <FormList
            isShow={showFormList}
            activeItem={activeForm}
            activeEvent={activeEvent}
            activeAllEvents={activeAllEvents}
            onItemClick={this.onFormListItemClick}
            onEventValueChange={this.onEventValueChange}
            onEventClick={this.onEventClick}
          />
          <LocusGroupList
            isShow={showLocusGroupList}
            activeItem={activeLocusGroup}
            activeForm={activeForm}
            activeEvent={activeEvent}
            activeAllEvents={activeAllEvents}
            onItemClick={this.onLocusGroupListItemClick}
            onEventValueChange={this.onEventValueChange}
            onEventClick={this.onEventClick}
          />
          <LocusList
            isShow={showLocusList}
            activeItem={activeLocus}
            activeForm={activeForm}
            activeLocusGroup={activeLocusGroup}
            activeEvent={activeEvent}
            activeAllEvents={activeAllEvents}
            onItemClick={this.onLocusListItemClick}
            onEventValueChange={this.onEventValueChange}
            onEventClick={this.onEventClick}
          />
          <EventList
            isShow={showSettingList}
            activeForm={activeForm}
            activeLocusGroup={activeLocusGroup}
            activeLocus={activeLocus}
            activeEvent={activeEvent}
            activeAllEvents={activeAllEvents}
            showAllSlaveEvents={this.showAllSlaveEvents}
            onEventValueChange={this.onEventValueChange}
            updateValuesList={() =>
              this.fetchFormEventListWithData(this.props, this.state)
            }
            onEventClick={this.onEventClick}
          />
        </div>
      </>
    )
  }
}

export default connect(
  state => ({
    activeSite: state.getIn(['profile', 'siteId']),
    activeDate: state.getIn(['logbookForm', 'activeDate']),
  }),
  {
    fetchFormEventListWithData,
    saveEventForm,
  },
)(injectIntl(Content))
